export default __webpack_public_path__ + "bonhomme.a7d9091.png";